// removed by extract-text-webpack-plugin
module.exports = {"popUp":"WBbM5Q9zHCepQpExEnR6h","bottomPadding":"MgU-px1vFk0Iy-dKMB_7v"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/PaymentMethods/styles.css
// module id = 1481
// module chunks = 0